import { DefaultButton, TitleText } from 'common/presentation/components';
import { Stack } from '@mui/material';
import React from 'react';
import CheckboxCard from '../components/CheckboxCard';
import { ApartmentIcon, HomeIcon } from 'assets/find-your-iokee-icons';
import { useTranslation } from 'react-i18next';
import Dimens from 'assets/dimens';
import { ArrowBack, ArrowForward } from '@mui/icons-material';
import useFindYourIokee from '../provider/find-your-iokee.provider';
import { IQuestion } from '../../domain/question.model';

interface Props {
	onBackClick: () => void
	onContinueClick: () => void
	question?: IQuestion
}

const PrivateSection: React.FC<Props> = (props) => {
	const { onBackClick, onContinueClick, question } = props;
	const { t } = useTranslation('translations');
	const {
		handleValueChange, isAnyAnswerSelected, getValue,
	} = useFindYourIokee();
	return (
		<Stack alignItems="center" spacing={{ md: 10, xs: 5 }}>
			<TitleText
				sx={{
					fontStyle: 'italic',
					fontSize: { md: Dimens.TITLE_TEXT_L, xs: Dimens.TITLE_TEXT_L_MOBILE },
				}}
			>
				{question?.description}
			</TitleText>
			<Stack
				direction="row"
				justifyContent={{
					md: 'center',
					xs: 'space-between',
					sm: 'space-between',
				}}
				spacing={{ md: 4, xs: 2 }}
			>
				{question?.answers?.map((el, index) => (
					<CheckboxCard
						key={el.id}
						title={el?.text?.toUpperCase()}
						icon={index === 0 ? <HomeIcon /> : <ApartmentIcon />}
						selected={getValue(question.id, el.id)}
						onClick={() => handleValueChange(question.id, el.id)}
					/>
				))}
			</Stack>
			<Stack direction="row" spacing={4}>
				<DefaultButton startIcon={<ArrowBack />} endIcon={null} onClick={onBackClick}>
					{t('back')}
				</DefaultButton>
				<DefaultButton disabled={!isAnyAnswerSelected(question?.id)} variant="contained" endIcon={<ArrowForward />} onClick={onContinueClick}>
					{t('continue')}
				</DefaultButton>
			</Stack>
		</Stack>
	);
};

export default PrivateSection;
